import { Injectable } from "@angular/core";
import { rate, draft, fullModel, quickQuote, CompanyCode, CompanyName, effectiveDate, expirationDate, auditFrequency, underwriterCode, BusinessName, InsuredType, yearsOfOperation, City, Line1, StateCode, StateDesc, ZipCode, ContactName, Phone1, ProducerCode, producerOfRecord, EMail, primaryState, liabMedicalExpensLmt, prodCompleteOperAggLmt, liabMedicalExpAggLmt, medicalExpensPerPerson, liabilityDeduApp, blanketRating, equipmentBreakdown, cEmpPracLiab, cEpliLimDed, cDoesLocMtf, CNoEmpMore, CNoEmpLess, cIsCyberCov, cCyberOption, cCyberCovLimit, CBlgExtRepCc, CExtRpCcOptions, fuelTank, enhancerEndorsement, cEnhancerPlusEndt, selfStorgFacilEnd, residCleanServCovAp, employeeDishonesty, electronicData, forgeryOrAlteration, interruptionCompOper, businessIncome, hireNonownAutoLiab, hireNonownAutoLiabCov, hireAutoNonownLiabType, hiredAutoLiabLimit, nonownedAutoLiabLmt, nonOwnedAutoLiabCov, compAndFundTranFrd, moldFungiWetDryRot, apartLosDamCusAuto, resLossDamCustAuto, contractorsEndorsement, terrorismCoverage, leadPoisoning, wantGenQstn, referenceObjectId, copyMailingAddress, description, incLmtFireDeptSc, outdoorSigns, moneyAndSecurity, empDishonestyApp, moldFungWetDryRtAp, wtrBckupSmpOvrfl, apartBuildCov, apartBldFineArtsCov, apartLosDamCusApp, apartBldLossDamLmt, apartmentBldEnd, restaurantsCov, resLosDamCusAutoAp, restEndorsement, locationId, BldgPropertyType, PropertyType, RentalProperty, BuildingSquareFootage, ConstructionType, NumberOfEmployees, DistanceFromFireStation, DistToNearestHydrant, PublicProtFireClas, Interest, OwnerOccupiedSqFtge, cRatingBasis, YearBuilt, NumberOfUnits, NumberOccupiedByOwners, NumberLeasedToOthers, NumberVacant, IsThereABasement, PercentFinished, BldReplacementCostEst, cReconstrConstr, ResAuRepMnufcProcOcup, bldHaveAFireAlarm, fireAlarmALocalAlarm, fireAlarmACenStnAlarm, fireAlarmAHrdwrSmkDet, fireAlarmABatopSmkDet, cBurgAlarm, cBurglarLocal, cBurgCentral, bldAnyOtherProtection, BldDeadboltDoorLocks, NoOfUnitsLetterCntrl, LeadPoisonYrConst, supplLeadPoisonAppl, fuelTankApplies, dmgPremisesRentYou, dmgPremRentYouSelCov, dmgPremRentYouLimit, swimmingPool, cBusinessIncExcl, offPrmBsnsInter, windstormOrHailExcl, optionalBldgDedu, OptionalPropertyDedu, windstrmHailPrcntDed, autoIncInInsurance, spoilage, comCondUntOwner, condominComUntOwnr, lossAssessmentLmt, MiscRealPropertyLmt, lossAssessmentDed, LossAssmntSubltForDed, foodContamination, timeElement, directDamage, vacancyPermitEndors, lossPayableClauses, earthquakeCoverage, BldOwnrAndSoleOccupant, BuildingLimitInsurance, includedBlanketRating, incRebudExpFollDis, greenUpgrades, ordinanceLaw, whRoofSurfaceLoss, ltCovAcvBldRc, debrisRemAddInsEndt, ClassCode, BusinssPersonalPropLmt, AreaOccupied, ClassificationPercen, cTenanatRelExp, utlSrvcDirectDmgApp, electronicDataCovApp, intOfCompOprCovApp, incLmtAccountsRecv, incLmtDpndntProp, incLmtPaperRecord, incLmtOutdoorProp, specBppTmpAwayFrmPrm, theftLimitations, brandsAndLabels, permYardsMaintainStr, seasonalIncPercentage, spoilageCovApp, earthquakeCovApplies, condDirctLiabEndt, medExpensExclusion, Endorsement, BusinessDesc, otherLocations, CSelectSubmission, cCompPolicy, namePriorInsurer, PriorInsPremium, ListOfPolicies, recentPolCancld, cReasons, cancelExplanation, YrsExpClass, ContractorResg, snowIceRemoval, remarkTradeContractors, InsuredConst, quotePolicy, AddressConst, ContactConst, ProducerConst, BusinessOwnersConst, BPLocationsConst, BPInlineOBJConst, BPBuildingConst, businessPersonalProp, building, autoSprinkleredSystem, cRoof, cElectrical, cWaterHeater, cHeating, cPlumbing, leadPoisoningAppl, BPBuildingCoverageConst, BPClassificationsConst, BPOptionalRTCCoveragesConst, BPGeneralQuestionsMUConst, BPCompanionPolicy, CCompPolicyType, CCompPolicyNumberRef, CExtendednamedinsured1, Extendednamedinsured1, IndRiskPremiumMod, cusGoodsLegalLiabLmt, cSmallContractor, CCoastalZone, name, maintenanceFees, brbBeutPrsEnhPrfLb, professionalClass, noOfFlTmBuPrEnPf, noOfFullTimeBarbers, noOfPartTimeBarbers, noOfPtTmBuPrEnPf, photography, BPIRPMOverridefactors, BPIRPMRating, BPIRPMRatingLevel, FactorType, IrpmCovUk, OverrideModifier, OverrideReason, OverrideValue, ProvideBreak, RiskFactor, StateName, TotalModifier, UnderwriterRiskConcern, foreignProducts, resAuRepMnufcProcOcup, LosseHistory, BPLossHistoryGeneralQuestionsConst, lossDate, lossDetail, lossLiabReserv, lossPropReserv, EmployeePayroll, GlCertSubcntrsPay, OwnerPartner, TemporaryWorker, UiSubcontractorPay, applicantLawsuit, applicantSubcontract, parkingLots, privateDriveways, roadHighways, totalPayroll, CrmProtAlmALocalAlm, CrmProtAlmACenStAlm, classificationDesc, CDescProducts } from "@app/contractor.constant";
import { WholeSaleRequest } from "@app/interfaces/wholesale/wholesale-request.modal";

@Injectable({
  providedIn: "root",
})
  
export class WholeSaleDataService {
  constructor() {}

  wholeSaleData: WholeSaleRequest = {
    [rate]: "Y",
    [draft]: "N",
    [fullModel]: "Y",
    [quickQuote]: "N",
    [quotePolicy]: {
      [CompanyCode]: "80",
      [CompanyName]: "MAPFRE Insurance Company",
      [effectiveDate]: "",
      [expirationDate]: "",
      [auditFrequency]: "Non-Auditable",
      [underwriterCode]: "",
      [InsuredConst]: {
        [BusinessName]: "",
        [InsuredType]: "",
        [yearsOfOperation]: "",
        [AddressConst]: {
          [City]: "",
          [Line1]: "",
          [StateCode]: "",
          [StateDesc]: "",
          [ZipCode]: "",
        },
        [ContactConst]: {
          [ContactName]: "",
          [Phone1]: "",
          [EMail]: ""
        },
        [Extendednamedinsured1]: {
          [CExtendednamedinsured1]: ''
        }
      },
      [ProducerConst]: {
        [ProducerCode]: "",
        [producerOfRecord]: "",
        [ContactConst]: {
          [ContactName]: "",
          [EMail]: "",
          [Phone1]: "",
        },
      },
      [BusinessOwnersConst]: {
        [primaryState]: "Massachusetts",
        [liabMedicalExpensLmt]: "1000000", //Default Hardcore
        [prodCompleteOperAggLmt]: "2000000",//Default Hardcore
        [liabMedicalExpAggLmt]: "2000000",//Default Hardcore
        [medicalExpensPerPerson]: "5000",//Default Hardcore
        [liabilityDeduApp]: "N",
        [blanketRating]: "N",
        [IndRiskPremiumMod]: "Y", //default value
        [equipmentBreakdown]: "Y",
        [cEmpPracLiab]: "Y",
        [cEpliLimDed]: "25000",
        [cDoesLocMtf]: "",
        [CNoEmpMore]: "",
        [CNoEmpLess]: "",
        [cIsCyberCov]: "",
        [cCyberOption]: "",
        [cCyberCovLimit]: "",
        [CBlgExtRepCc]: "",
        [CExtRpCcOptions]: "",
        [fuelTank]: "N",
        [enhancerEndorsement]: "Y",
        [cEnhancerPlusEndt]: "",
        [selfStorgFacilEnd]: "N",
        [cusGoodsLegalLiabLmt]: "50000",
        [residCleanServCovAp]: "N",
        [employeeDishonesty]: "N",
        [electronicData]: "N",
        [forgeryOrAlteration]: "N",
        [interruptionCompOper]: "N",
        [businessIncome]: "N",
        [hireNonownAutoLiab]: "",
        [hireNonownAutoLiabCov]: "",
        [hireAutoNonownLiabType]: "Both",
        [hiredAutoLiabLimit]: "",
        [nonownedAutoLiabLmt]: "",
        [nonOwnedAutoLiabCov]: "",
        [compAndFundTranFrd]: "N",
        [moldFungiWetDryRot]: "N",
        [apartLosDamCusAuto]: "N",
        [resLossDamCustAuto]: "N",
        [contractorsEndorsement]: "N",
        [terrorismCoverage]: "Y",
        [leadPoisoning]: "N",
        [wantGenQstn]: "Y",
        [BPLocationsConst]: [{
          [referenceObjectId]: "1",
          [copyMailingAddress]: "",
          [name]: "",
          [description]: "",
          [AddressConst]: {
            [CCoastalZone]: "",
            [cSmallContractor]: "",
            [City]: "",
            [Line1]: "",
            [StateCode]: "MA",
            [StateDesc]: "Massachusetts",
            [ZipCode]: "",
          },
          [BPInlineOBJConst]: {
            [incLmtFireDeptSc]: "N",
            [outdoorSigns]: "N",
            [moneyAndSecurity]: "N",
            [empDishonestyApp]: "",
            [moldFungWetDryRtAp]: "",
            [wtrBckupSmpOvrfl]: "N",
            [apartBuildCov]: "N",
            [apartBldFineArtsCov]: "",
            [apartLosDamCusApp]: "N",
            [apartBldLossDamLmt]: "",
            [apartmentBldEnd]: "",
            [restaurantsCov]: "N",
            [resLosDamCusAutoAp]: "",
            [restEndorsement]: "",
          },
        }],
        [BPBuildingConst]: [{
          [locationId]: "1",
          [building]: "",
          [businessPersonalProp]: "",
          [BldgPropertyType]: "Wholesale Risks",
          [PropertyType]: "",
          [RentalProperty]: "",
          [BuildingSquareFootage]: "",
          [ConstructionType]: "",
          [NumberOfEmployees]: "0",
          [DistanceFromFireStation]: "",
          [DistToNearestHydrant]: "",
          [PublicProtFireClas]: "",
          [autoSprinkleredSystem]: "",
          [Interest]: "",
          [OwnerOccupiedSqFtge]: "",
          [cRatingBasis]: "Replacement Cost",
          [YearBuilt]: "",
          [cRoof]: "",
          [cElectrical]: "",
          [cWaterHeater]: "",
          [cHeating]: "",
          [cPlumbing]: "",
          [NumberOfUnits]: "",
          [NumberOccupiedByOwners]: "",
          [NumberLeasedToOthers]: "",
          [NumberVacant]: "",
          [IsThereABasement]: "N",
          [PercentFinished]: "",
          [BldReplacementCostEst]: "",
          [cReconstrConstr]: "",
          [resAuRepMnufcProcOcup]: "N",
          [bldHaveAFireAlarm]: "Y",
          [fireAlarmALocalAlarm]: "",
          [fireAlarmACenStnAlarm]: "",
          [fireAlarmAHrdwrSmkDet]: "",
          [fireAlarmABatopSmkDet]: "",
          [cBurgAlarm]: "",
          [CrmProtAlmALocalAlm]: "",
          [CrmProtAlmACenStAlm]: "",
          [bldAnyOtherProtection]: "N/A",
          [BldDeadboltDoorLocks]: "Y",
          [leadPoisoningAppl]: "",
          [NoOfUnitsLetterCntrl]: "0",
          [LeadPoisonYrConst]: "Before 1978",
          [supplLeadPoisonAppl]: "",
          [fuelTankApplies]: "N",
          [dmgPremisesRentYou]: "Y",
          [dmgPremRentYouSelCov]: "Basic",
          [dmgPremRentYouLimit]: "50000",//Default Hardcore
          [swimmingPool]: "N",
          [cBusinessIncExcl]: "N",
          [offPrmBsnsInter]: "N",
          [windstormOrHailExcl]: "N",
          [optionalBldgDedu]: "Y",
          [OptionalPropertyDedu]: "500",
          [windstrmHailPrcntDed]: "",
          [autoIncInInsurance]: "",
          [spoilage]: "N",
          [comCondUntOwner]: "",
          [condominComUntOwnr]: "",
          [lossAssessmentLmt]: "10000",
          [MiscRealPropertyLmt]: "5000",
          [lossAssessmentDed]: "500",
          [LossAssmntSubltForDed]: "1050",
          [foodContamination]: "N",
          [timeElement]: "N",
          [directDamage]: "N",
          [vacancyPermitEndors]: "N",
          [lossPayableClauses]: "N",
          [earthquakeCoverage]: "N",
          [BldOwnrAndSoleOccupant]: "",
          [BPBuildingCoverageConst]: {
            [BuildingLimitInsurance]: "",
            [includedBlanketRating]: "N",
            [incRebudExpFollDis]: "N",
            [greenUpgrades]: "N",
            [ordinanceLaw]: "N",
            [whRoofSurfaceLoss]: "N",
            [ltCovAcvBldRc]: "N",
            [debrisRemAddInsEndt]: "N",
          },
          [BPClassificationsConst]: {
            [ClassCode]: "",
            [classificationDesc]:"",
            [BusinssPersonalPropLmt]: "",
            [AreaOccupied]: "Percentage",
            [ClassificationPercen]: "100",
            [cTenanatRelExp]: "N",
            [includedBlanketRating]: "N",
            [maintenanceFees]: "N",
            [greenUpgrades]: "N",
            [utlSrvcDirectDmgApp]: "N",
            [electronicDataCovApp]: "N",
            [intOfCompOprCovApp]: "N",
            [incLmtAccountsRecv]: "N",
            [incLmtDpndntProp]: "N",
            [incLmtPaperRecord]: "N",
            [incLmtOutdoorProp]: "N",
            [specBppTmpAwayFrmPrm]: "N",
            [theftLimitations]: "N",
            [brandsAndLabels]: "N",
            [permYardsMaintainStr]: "N",
            [seasonalIncPercentage]: "25",
            [spoilageCovApp]: "N",
            [earthquakeCovApplies]: "N",
            [medExpensExclusion]: "N",          },
        }],
        [BPIRPMRating]: [
          {
            [ProvideBreak]: "Y", // backend default
            [StateName]: "Massachusetts", // backend default
            [BPIRPMRatingLevel]: [
              {
                [FactorType]: "Both Combined", // backend default
                [IrpmCovUk]: "MA-Both Combined-Both Combined", // backend default
                [OverrideModifier]: "",
                [TotalModifier]: "",
              },
            ],
            [BPIRPMOverridefactors]: [
              {
                [FactorType]: "", //backend default
                [UnderwriterRiskConcern]: "",
                [RiskFactor]: "",
                [OverrideReason]: "",
                [OverrideValue]: "",
                [TotalModifier]: "",
              }
            ],
          },
        ],
        [BPGeneralQuestionsMUConst]: {
          [BusinessDesc]: "",
          [otherLocations]: "",
          [foreignProducts]: "",
          [CDescProducts]:"",
          [CSelectSubmission]: "New Business Policy to MAPFRE",
          [BPCompanionPolicy]: {
            [CCompPolicyType]: "",
            [CCompPolicyNumberRef]: "",
          },
          [cCompPolicy]: "N",
          [namePriorInsurer]: "Other",
          [PriorInsPremium]: "0",
          [ListOfPolicies]: "",
          [recentPolCancld]: "",
          [cReasons]: "",
          [cancelExplanation]: "",
          [YrsExpClass]: "",
          [LosseHistory]:"",
          [ContractorResg]: "123456",
          [snowIceRemoval]: "N",
          [BPLossHistoryGeneralQuestionsConst]: [],
          [privateDriveways]: "N",
          [parkingLots]: "N",
          [roadHighways]: "N",
          [OwnerPartner]: "28600",
          [remarkTradeContractors]: "",
        },
      },
    },
  };
}
